import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-btn-primary-grey',
  templateUrl: './btn-primary-grey.component.html',
  styleUrls: ['./btn-primary-grey.component.css']
})
export class BtnPrimaryGreyComponent implements OnInit {
  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  @Input() btnLabel: string;
  @Input() isDisabled: string;
  @Input() routeTo: string;
  @Input() link: string;
  constructor() { }

  ngOnInit() {
  }
  onBtnClick(): boolean {
    if (this.isDisabled === 'true') {
      return false;
    }
    // alert('clicked btn in child component');
    this.callOnClick.emit();
    return true;
  }
}
